export default "__VITE_ASSET__Dslh84BF__"